module.exports = __webpack_public_path__ + "img/bg_note_04.d7f7a125.jpg";